import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ProductsPage = () => {
  return (
    <>
      <Helmet>
        <title>Our Products | Naru Tofu - Tofu & Soymilk</title>
        <meta name="description" content="Explore Naru Tofu's premium product range - Momen Firm Tofu Block and Fresh Soymilk. Handcrafted with non-GMO soybeans, zero preservatives." />
        <link rel="canonical" href="https://narutofu.com/products" />
      </Helmet>
      <section className="section-padding" style={{ minHeight: '100vh' }}>
      <div className="container">
        <h1 className="hero-large" style={{ textAlign: 'center', marginBottom: '24px' }}>
          Our Products
        </h1>
        <p className="body-large" style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '800px', margin: '0 auto 60px', color: 'var(--text-secondary)' }}>
          Premium Japanese tofu and soymilk made fresh in Bangalore. Plant-based, high-protein, clean ingredients.
        </p>
        
        <div className="grid-two-column" style={{ gap: '40px' }}>
          {/* Tofu Card */}
          <Link to="/products/tofu" style={{ textDecoration: 'none' }}>
            <div className="product-card hover-lift" style={{ padding: '40px', cursor: 'pointer', height: '100%' }}>
              <h2 className="heading-1" style={{ marginBottom: '16px' }}>Momen Firm Tofu</h2>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
                Traditional Japanese-style firm tofu, perfect for grilling, frying, or adding to your favorite dishes.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginBottom: '24px' }}>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ 15.8g protein per 100g</li>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ Zero cholesterol</li>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ Non-GMO soybeans</li>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ No preservatives</li>
              </ul>
              <div className="btn-icon">
                Learn more
                <ArrowRight size={16} />
              </div>
            </div>
          </Link>
          
          {/* Soymilk Card */}
          <Link to="/products/soymilk" style={{ textDecoration: 'none' }}>
            <div className="product-card hover-lift" style={{ padding: '40px', cursor: 'pointer', height: '100%' }}>
              <h2 className="heading-1" style={{ marginBottom: '16px' }}>Fresh Soymilk</h2>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
                Creamy, nutritious soymilk made from premium soybeans. A delicious plant-based alternative to dairy.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginBottom: '24px' }}>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ Rich in plant protein</li>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ Lactose-free</li>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ No added sugar</li>
                <li className="body-regular" style={{ marginBottom: '8px' }}>✓ Fresh daily</li>
              </ul>
              <div className="btn-icon">
                Learn more
                <ArrowRight size={16} />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
    </>
  );
};

export default ProductsPage;
